// Specialised service subpages (/services/:slug)
export const SERVICES = [
  {
    slug: "balcony-invisible-grills",
    name: "Balcony Invisible Grills",
    headline: ["Balcony Invisible", "Grills Hyderabad"],
    metaTitle: "Balcony Invisible Grills Hyderabad | Sudeeksha",
    metaDesc: "Premium balcony invisible grill installation in Hyderabad. High-tension SS316 steel cables, child & pet safe, view-preserving. Free site visit. Call +91 70325 07529.",
    intro:
      "Our balcony invisible grills secure your balcony with near-invisible high-tension stainless-steel cables anchored into aluminium tracks — so your view, light and breeze stay open while children and pets stay safe.",
    bullets: [
      "SS304 or SS316 stainless-steel cables",
      "Cable spacing under 3 inches for safety",
      "Marine-grade finish for monsoon durability",
      "Suited for high-rise and open balconies",
      "Written warranty + free tension check-ups",
    ],
    process: [
      ["Free site visit", "We measure your balcony and understand your requirement."],
      ["Transparent quote", "You get a same-day written estimate with no hidden costs."],
      ["Installation", "Our own trained crew installs anchors, tracks and tensioned cables."],
      ["Tension check & handover", "We stress-test the cables and walk you through care instructions."],
    ],
    faqs: [
      ["Will the cables block my view?", "No — the stainless-steel cables are thin and near-transparent against the sky, so your balcony view stays intact."],
      ["Is it safe for small children?", "Yes. Cables are tensioned and spaced under 3 inches apart, so toddlers can't squeeze through."],
    ],
  },
  {
    slug: "child-safety-grills",
    name: "Child Safety Grills",
    headline: ["Child Safety", "Invisible Grills"],
    metaTitle: "Child Safety Invisible Grills Hyderabad | Sudeeksha",
    metaDesc: "Child-safe invisible grills for balconies and windows in Hyderabad. Tight cable spacing, high tension and marine-grade SS316 — peace of mind for parents.",
    intro:
      "Designed specifically with young families in mind: tight-spaced, high-tension stainless-steel cables that prevent children from leaning out, slipping through or climbing balcony railings — without closing in the space.",
    bullets: [
      "Spacing kept under 3 inches end-to-end",
      "High-tension cabling resists push and pull",
      "Non-sharp aluminium tracks around the frame",
      "Removable in future if you ever renovate",
      "Trusted by families in Hyderabad high-rises",
    ],
    process: [
      ["Child-first measurement", "We measure every gap and railing height to a child-safe standard."],
      ["Written quote", "Same-day transparent pricing — no obligation."],
      ["Clean installation", "No dust, no damage — our crew installs and cleans up."],
      ["Safety walkthrough", "We demonstrate the finished strength and the warranty cover."],
    ],
    faqs: [
      ["How is this different from regular invisible grills?", "The same product, installed with tighter spacing and extra attention to railing-height risk points typical in homes with toddlers."],
      ["Is it removable later?", "Yes — tracks are screwed into the frame and can be removed cleanly if you move or renovate."],
    ],
  },
];

export const serviceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
